import React from 'react'

function Intro() {
  return (
    <section className='intro'>
        <div className="container">
            <h2>Hi</h2>
            <p>"Hello, I'm Subhajit Nandi, a final-year B.Tech student at Haldia Institute Of Technology. 
              I am passionate about applying technology to solve real-world problems and am constantly seeking opportunities to expand my knowledge and skills in the field.</p>
            <div className="button-wrapper">
                <a href="https://drive.google.com/file/d/1mhk4WKZhFbqwjf4SGtKfUGcJFTvRkesX/view?usp=drive_link" className="btn">Download Cv</a>
            </div>
        </div>

    </section>
  )
}

export default Intro